import moment from 'moment'

export const isLessThenDate = (value, unit, date) =>
  moment().diff(date, unit) > parseInt(-value)

export const isInPast = date => moment(date) < moment()
